import { useMutation } from 'react-query'
import * as AppPreferencesClient from 'api/clients/AppPreferencesClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'

type Variables = { [preference: string]: any }

export type Options = Omit<UseMutationOptions<void, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const useUpdateUserAppPreferences = (options?: Options) =>
  useMutation<void, unknown, Variables>(
    ['userAppPreferences'],
    async (variables) => {
      const response = await AppPreferencesClient.updateUserAppPreferences(variables)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        reportError('Failed to update preferences', {
          metaData: {
            response: response.data,
          },
        })
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
    },
    {
      ...options,
    },
  )
